import { Component } from '@angular/core';

@Component({
  selector: 'ccl-ui-components',
  imports: [],
  template: `
    <p>
      ccl-ui-components works!
    </p>
  `,
  styles: ``
})
export class CclUiComponents {

}
